<script>
    import { items } from './stores/cart.js'; // adjust the path if necessary
    import Fa from 'svelte-fa';
    import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
    import { navigate } from 'svelte-routing';
    import analytics from './services/analytics.js';

    analytics.trackPageView(window.location.pathname, 'Cart');
  
    
    let totalItems = 0;
  
    $: totalItems = $items.length ?? 0;
  
    function handleClick() {
      // replace '/shopping' with the correct path to your shopping page
      
      console.log(totalItems);
      
      if (totalItems > 0) {
        navigate('/cart');
      }
    }
</script>
<style>
  /* Styling for the disabled state */
  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
</style>

<div class="relative">
  <button on:click={handleClick} class="border-none" class:disabled={totalItems == 0}>
    <Fa icon={faShoppingCart} size="2x" />
    <span class="block absolute -left-1 -bottom-1 mb-2 p-1 bg-red-500 text-white text-xs rounded-full">{totalItems}</span>
  </button>
</div>


